export const DOCTOR_LOGOUT_EVENT = 'doctorLogout';

/**
 * Dispatch a global browser event to notify interested listeners that the doctor is logging out
 * and all doctor-specific data should be cleared.
 */
export function triggerDoctorLogout() {
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    console.log('🔔 Dispatching doctor logout event');
    window.dispatchEvent(new Event(DOCTOR_LOGOUT_EVENT));
  }
}

export const DOCTOR_SESSION_EXPIRED_EVENT = 'doctorSessionExpired';

/**
 * The server refused the refresh token (expired, revoked, already used): the stored tokens are gone,
 * so every screen must stop acting signed in and go back to sign-in.
 */
export function triggerDoctorSessionExpired() {
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new Event(DOCTOR_SESSION_EXPIRED_EVENT));
  }
}

// Legacy aliases for backward compatibility - will be removed
export const USER_LOGOUT_EVENT = DOCTOR_LOGOUT_EVENT;
export const triggerUserLogout = triggerDoctorLogout;